import React from 'react';
import clsx from 'clsx';
import { Delete } from 'lucide-react';

export interface NumericKeypadProps {
    /** digit string (no separators) */
    value: string;
    onChange: (digits: string) => void;
    maxLength?: number;
    /** `cash` strips leading zeros and has a 000 key; `pin` keeps them (012345 is a valid PIN). */
    variant?: 'cash' | 'pin';
    className?: string;
}

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '000', '0', 'back'] as const;
const PIN_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'back'] as const;

/** Landscape cash keypad (also the PIN pad). */
export const NumericKeypad: React.FC<NumericKeypadProps> = ({ value, onChange, maxLength = 12, variant = 'cash', className }) => {
    const press = (k: string) => {
        if (k === 'back') return onChange(value.slice(0, -1));
        const next = variant === 'pin' ? value + k : (value + k).replace(/^0+(?=\d)/, '');
        if (next.length <= maxLength) onChange(next);
    };
    return (
        <div className={clsx('grid grid-cols-3 auto-rows-fr gap-2.5', className)}>
            {(variant === 'pin' ? PIN_KEYS : KEYS).map((k) => k === '' ? <span key="blank" aria-hidden /> : (
                <button
                    key={k}
                    type="button"
                    aria-label={k === 'back' ? 'Backspace' : k}
                    onClick={() => press(k)}
                    className="flex min-h-[56px] items-center justify-center rounded-md border border-line-subtle bg-surface-card text-[26px] font-extrabold tnum shadow-xs transition-transform active:scale-[.96] active:bg-surface-sunken"
                >
                    {k === 'back' ? <Delete className="w-[26px] h-[26px] text-ink-secondary" /> : k}
                </button>
            ))}
        </div>
    );
};
export default NumericKeypad;
